import { Action, ActionType } from '../actions/baseAction.types'
import { TrackAction } from '../actions/trackAction/trackAction.types'

export enum UXComponentType {
  // Primitives
  Button = 'BUTTON',
  Icon = 'ICON',
  Label = 'LABEL',
  LazyLoader = 'LAZY_LOADER',
  Text = 'TEXT',
  Image = 'IMAGE',
  // Composites
  Swimlane = 'SWIMLANE',
  Section = 'SECTION',
  // Custom
  Calendar = 'CALENDAR',
  SearchBar = 'SEARCH_BAR',
  ProductCard = 'PRODUCT_CARD',
  ProductCardCollapsed = 'PRODUCT_CARD_COLLAPSED',
  //TODO: fix it on sdui
  QuickFilter = 'CONCEPT',
  Concept = 'QUICK_FILTER',
  //--
  ChefRowCard = 'CHEF_CARD',
  CollectionRowCard = 'COLLECTION_CARD',
  Banner = 'BANNER',
  HeroBanner = 'HERO_BANNER',
  Modal = 'MODAL',
  Tab = 'TAB',
  OrderStatusCard = 'ORDER_STATUS_CARD',
  OrderCardSummary = 'ORDER_CARD_SUMMARY',
  NoItemsCard = 'NO_ITEMS_CARD',
  Separator = 'SEPARATOR',
  PriceBreakdown = 'PRICE_BREAKDOWN',
  PriceBreakdownItem = 'PRICE_BREAKDOWN_ITEM'
}

export type BaseUXComponentActions = {
  onView: Action<ActionType>[]
  onScroll: Action<ActionType>[]
  onClick: Action<ActionType>[]
  onAdd?: TrackAction[]
  onRemove?: TrackAction[]
}

export enum UXComponentVersion {
  V1 = 1,
  V2 = 2
}

export type BaseUXComponent<K extends UXComponentType> = {
  type: K
  version: UXComponentVersion
  index?: number
  actions?: Partial<BaseUXComponentActions>
}
